import React, { Component } from 'react'

export const IonIconCard = () => <ion-icon id="down_card_icon" name="card-outline" />
export const IonIconRua = () => <ion-icon id="icon_input" name="trail-sign-outline" />
export const IonIconCardClean = () => (
  <ion-icon style={{ top: '.4rem' }} name="card-outline"></ion-icon>
)
